<template>
    <div class="page-foko" :class="diapoZoom?'diapo-zoom':''">

        <div class="diaporama">
            <diaporama :medias="foko.diaporama"></diaporama>

            <a href="#" class="btn-fs" @click.prevent="diapoZoom=!diapoZoom">
                <icon-base v-if="!diapoZoom" size="2vw" icon-color="#fff">
                    <icon-zoom ></icon-zoom>
                </icon-base>
            </a>
            <a href="#"
               @click.prevent="closeClick"
               class="btn-close"
            >
                <icon-base size="4vw" icon-color="#fff">
                    <icon-close></icon-close>
                </icon-base>
            </a>
        </div>

        <div class="texts">
            <h1>{{foko.title}}</h1>
            <div class="texts-container">
                <div>
                    <h2>Historique du peuplement</h2>
                    <p>{{foko.peuplementtxt}}</p>
                </div>
                <div>
                    <h2>Us et coutumes</h2>
                    <p>{{foko.coutumestxt}}</p>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import DB from "shared-src/data/DB";
    import IconBase from "shared-src/icons/IconBase";
    import IconClose from "shared-src/icons/IconClose";
    import IconZoom from "shared-src/icons/IconZoom";
    import Diaporama from "../components/diaporama/Diaporama";

    export default {
        name: "PageFoko",
        components:{
            Diaporama,
            IconBase,
            IconClose,
            IconZoom
        },
        data() {
            return {
                /**
                 * @type {PageFokoModel}
                 */
                foko:null,
                diapoZoom:false
            }
        },
        created() {
            this.foko=DB.inst.getModel(
                "foko",
                this.$router.currentRoute.params.id
            );
        },
        methods:{
            closeClick(){
                if(this.diapoZoom){
                    this.diapoZoom=false;
                }else{
                    this.$router.push(this.foko.royaume.url())
                }
            }
        }
    }
</script>

<style lang="less">
    .page-foko{
        @iconMargin:2vw;
        >*{
            position: absolute;
            height: 100%;
            width: 50%;
        }
        --diapo-width:67%;

        >.diaporama{
            right: 0;
            width:var(--diapo-width);
        }
        >.texts{
            left: 0;
            width: calc( 100% - var(--diapo-width) );
        }
        >.diaporama{
            background-color: #333333;
            .btn-fs{
                z-index: 2;
                position: absolute;
                top: 3vw;
                left: 2.5vw;
            }
            .btn-close{
                z-index: 2;
                position: absolute;
                top: 2vw;
                right: 2vw;
            }
        }
        >.texts{

            background: #065D44 url("../assets/textures/bg-texture-vert.jpg") top left;
            background-size: cover;
            overflow-y: auto;
          display: flex;
          flex-direction: column;

            >h1{
                display: flex;
                justify-content: flex-end;
                align-items: flex-end;
                margin: 1vw 3vw 2vw 2vw;
                height: 10vw;
                font-size: 3.5vw;
            }
            >.texts-container{
              flex-grow: 1;
                position: relative;

                &:before{
                    content: "";
                    display: block;
                    height: 4px;
                    background-color: #fff;
                    width: 24vw;
                    position: absolute;
                    top: 0;
                    left: -12.5vw;
                }

                border-left: 1px solid #fff;
                margin-left: 5.5vw;
                padding: 3vw 8vw 4vw 3vw;
                >div{
                    >h2{
                        margin-bottom: 0.5vw;
                    }
                    >p{
                        margin-bottom: 3vw;
                    }
                }
            }
        }

        >.diaporama,>.texts{
            transition: all 1s;
        }

        &.diapo-zoom{
            >.diaporama{
                width: 100%;
            }
            >.texts{
                left: calc( (100% - var(--diapo-width)) * -1 );
            }
        }
    }
</style>